import { SVGProps } from 'react';
import { ReactComponent } from 'icons/warning-icon.svg';

/**
 * @deprecated Move to storybook instead
 */
export const WarningIcon = (props: SVGProps<SVGSVGElement>) => {
  return <ReactComponent {...props} />;
};
